import { gsap } from "gsap";
import { useLayoutEffect, useRef } from "react";

export function TokenLoginSpinner() {
  const spinnerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const spinner = spinnerRef.current;
    if (!spinner) return;

    const dots = spinner.querySelectorAll<HTMLElement>("[data-token-dot]");
    const media = gsap.matchMedia();

    media.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.to(spinner, {
        rotation: 360,
        duration: 1.15,
        ease: "none",
        repeat: -1,
      });
      gsap.to(dots, {
        scale: 0.62,
        opacity: 0.45,
        duration: 0.55,
        ease: "sine.inOut",
        repeat: -1,
        yoyo: true,
        stagger: 0.18,
      });
    });

    return () => media.revert();
  }, []);

  return (
    <div
      ref={spinnerRef}
      className="tokenLogin_spinner"
      role="status"
      aria-label="로그인 중"
    >
      <span data-token-dot aria-hidden="true" />
      <span data-token-dot aria-hidden="true" />
      <span data-token-dot aria-hidden="true" />
    </div>
  );
}
